// extracted by mini-css-extract-plugin
export default {"underLine":"D9AxH6xoV_unw9dLLuMe","disableSelection":"laqRrR8oGXCUQd3ONUv8"};